import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import SEO from "../SEO/SEO";
import { motion } from "framer-motion";
import Adelaidebanner from "../Assets/Services/Adelaide-banner-img.png";
import Officecleaning from "../Assets/CommercialCleaning/Once-off-Cleaning.png";
import AgedCare from "../Assets/CommercialCleaning/Regular-house-cleaning.png";
import Schoolcleaning from "../Assets/CommercialCleaning/End-of-Lease-Cleaning.png";
import Medicalcleaning from "../Assets/CommercialCleaning/Deep-cleaning.png";
import trueicon from "../Assets/HouseCleaning/true-icon.png";
import { FaArrowRight, FaPhoneAlt } from "react-icons/fa";
import { Link } from "react-router-dom";
import getaquote from "../Assets/get_a_quote.jpg";
import FaqPage from "../Services/FaqPage";
import SuburbsSection from "./SuburbsSection";
import React, { useState, useEffect, useRef } from "react";
import api, { PUBLIC_BASE_URL, BASE_URL } from "../Api/api";

const services = [
  {
    title: "Deeper Clean",
    desc: "Our advanced steam cleaning technology penetrates deep into the carpet fibers, extracting stubborn dirt, stains, and grime that traditional vacuuming and dry cleaning can't reach. The result? A noticeably cleaner, softer, and longer-lasting carpet.",
    img: Officecleaning,
    alt: "Deeper Clean",
  },
  {
    title: "Eco-Friendly",
    desc: "We care about your health and the planet. Our steam cleaning method uses minimal water and biodegradable cleaning agents, making it a sustainable and eco-conscious choice for your carpet care needs.",
    img: AgedCare,
    alt: "Eco-Friendly",
  },
  {
    title: "Hygienic",
    desc: "The high-temperature steam effectively kills bacteria, dust mites, and mold spores, making your space healthier — especially for allergy sufferers and families with kids or pets.",
    img: Schoolcleaning,
    alt: "Hygienic",
  },
  {
    title: "Time-Efficient",
    desc: "Steam cleaning not only delivers superior results but also dries faster than traditional methods. That means less downtime and minimal disruption to your day-to-day routine.",
    img: Medicalcleaning,
    alt: "Time-Efficient",
  },
];

const CarpetSteamCleaning = () => {
  const [activeIndex, setActiveIndex] = useState(1); // second item open by default

  const toggleFAQ = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  const [item, setItem] = useState(null);

  useEffect(() => {
    api.get(`/whychoosehousecleaningservice/view/5`).then((res) => {
      setItem(res.data);
    });
  }, []);

  // Fetch slider content from API
  const [sliderData, setSliderData] = useState({
    headline: "Carpet Steam Cleaning Services",
    subtext: "",
  });

  useEffect(() => {
    api
      .get("service-slider/carpet-steam-cleaning")
      .then((res) => {
        if (res.data) {
          setSliderData({
            headline: res.data.headline,
            subtext: res.data.subtext,
          });
        }
      })
      .catch((err) => console.error("Slider Fetch Error", err));
  }, []);

  return (
    <div>
      <SEO />
      <Header />

      <section
        className="hero-section py-24 text-white text-center relative"
        style={{
          background: `url(${Adelaidebanner}) center/cover`,
          position: "relative",
        }}
      >
        <div className="container mx-auto px-4 relative z-10 mt-5">
          <motion.h1
            className="text-4xl md:text-5xl lg:text-6xl font-bold mb-4 mt-5"
            initial={{ opacity: 0, y: -30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            {sliderData.headline || "Carpet Steam Cleaning Services"}
          </motion.h1>

          {sliderData.subtext && (
            <motion.p
              className="text-lg mb-4 px-4"
              style={{ maxWidth: "800px", margin: "0 auto" }}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3, duration: 0.6 }}
            >
              {sliderData.subtext}
            </motion.p>
          )}

          <motion.p
            className="text-lg"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4, duration: 0.6 }}
          >
            <span>
              Home
              <Link
                to="/adelaide-service"
                className="text-decoration-none text-white"
              >
                / Services
              </Link>
            </span>
          </motion.p>

          <div className="quote-buttons d-flex flex-column flex-md-row justify-content-center gap-3 mt-5">
            <Link
              to="/free-quote"
              className="btn btn-danger d-inline-flex align-items-center gap-2"
            >
              Get Free Quote <FaArrowRight />
            </Link>
            <Link
              to="tel:0406958557"
              className="btn btn-primary d-inline-flex align-items-center gap-2"
            >
              Call Now <FaPhoneAlt />
            </Link>
          </div>
        </div>

        {/* Optional Overlay */}
        <div className="absolute inset-0 bg-black opacity-40 z-0"></div>
      </section>

      <section className="why-choose py-5">
        <div className="why-container container d-flex flex-column flex-lg-row align-items-center justify-content-between">
          <div className="why-text mb-4 mb-lg-0">
            <h2 className="fw-bold mb-4">
              {item?.heading.split(" ").slice(0, -3).join(" ")}{" "}
              <span>{item?.heading.split(" ").slice(-3).join(" ")}</span>
            </h2>
            <ul className="list-unstyled">
              {item?.points.map((point, index) => (
                <li className="mb-3 d-flex align-items-start" key={index}>
                  <img src={trueicon} alt="check" className="me-2 icon" />
                  <span>{point}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="why-image text-center">
            <div className="d-flex flex-column flex-md-row align-items-center justify-content-center gap-4">
              <div>
                <img
                  src={`${PUBLIC_BASE_URL}${item?.before_image}`}
                  alt="Before"
                  className="img-fluid rounded shadow"
                  style={{ maxWidth: "300px" }}
                />
                <div className="caption fw-bold mt-2">Before</div>
              </div>

              <div className="fw-bold display-5 mx-2 d-none d-md-block">→</div>

              <div>
                <img
                  src={`${PUBLIC_BASE_URL}${item?.after_image}`}
                  alt="After"
                  className="img-fluid rounded shadow"
                  style={{ maxWidth: "300px" }}
                />
                <div className="caption fw-bold mt-2">After</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="service-options text-center">
        <div className="container">
          <h2 className="section-title">
            Why Carpet Steam Cleaning is Better Than Traditional Methods
          </h2>
          <div className="row">
            {services.map((service, index) => (
              <div className="col-sm-6 col-lg-3 mb-4" key={index}>
                <div className="service-card">
                  <div className="icon-box mb-3">
                    <img
                      src={service.img}
                      alt={service.alt}
                      className="img-fluid"
                    />
                  </div>
                  <h3>{service.title}</h3>
                  <p>{service.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <FaqPage categoryId="Carpet steam cleaning" />

      <SuburbsSection />

      <section className="quote-section pt-5">
        <div className="row">
          <div className="col-md-6">
            <div className="quote-container container text-center">
              <h2 className=" fw-bold mb-3">Book Your Carpet Steam Cleaning Now!</h2>
              <p className="mb-4 text-muted mt-5">
                Give your carpets a new lease on life with Shiny Cleaning’s expert carpet steam cleaning services in Adelaide & Melbourne .
 We bring the tools, skills, and care to refresh your flooring and improve your indoor environment. <br/>
👉 Request a free quote today and enjoy cleaner, healthier carpets!
              </p>

              <div className="quote-buttons d-flex flex-column flex-md-row justify-content-center gap-3 mt-5">
                <Link
                  to="/free-quote"
                  className="btn btn-outline-info d-inline-flex align-items-center gap-2 "
                >
                  Get Free Quote <FaArrowRight />
                </Link>
                <Link
                  to="tel:0406958557"
                  className="btn btn-outline-primary d-inline-flex align-items-center gap-2"
                >
                  Call Now <FaPhoneAlt />
                </Link>
              </div>
            </div>
          </div>

          <div className="col-md-6 px-5">
            <img src={getaquote} className="h-75 w-75" />
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default CarpetSteamCleaning;
